const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		preventSortOfField: {
			userTitle: true,
			preparedEntityType: true,
			entityTitle: true
		},
		buttonContext: 'protocol',
		renderEmptyBeforReady: false,
		showHead: false,
		showInsertButton: false,
		showColorCodedRows: true,
		showAllBorders: false,
		showDelimiterBorders: true,
		inline: true,
		maxNrOfExportElements: 500000,
		privilegeBase: 'cms_protocolActions',
		rowActionsProperties: {
			colWidth: '125px'
		},
		rowActions: {},
		customColActionsFile: 'templates/protocol/protocol/table/customColActions',
		// useSelectionObjectFormat: true,
		// useSelectionObjectKeyAttribute: 'routeID'
	},

	model: {
		resourceFilters: {
			order: [{
				fieldCode: 'protocolActionID',
				direction: 'desc'
			}]
		},
		// baseFilters: {
			// entityID: 123,
			// entityType: 'routeComponent',
			// entityContext: 'route',
			// templateAtomID: 321,
			// attribute: 'componentName'
		// }
	},

	methods: {

		dataDealer: function(){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_protocol_protocol_controller', function(controller){
					self.model.controller = controller
				});
			}

			if(self.model.controller && !self.config.usage){
				self.config.usage = self.model.controller.config.usage || '';
			}
		},

		sanitizeResourceFilters: function(storage, resourceFilters, actionKey){

			if(actionKey === 'refreshResources'){
				resourceFilters = resourceFilters || {};
				resourceFilters.baseFilters = resourceFilters.baseFilters || {};

				if(!this.model.baseFilters){
					this.model.baseFilters = this.getResourceRegisterContent('protocol') || {}
				}
				utils.refReplace(resourceFilters.baseFilters, this.model.baseFilters || {})

				resourceFilters.filters = resourceFilters.filters || {};
			}
			return resourceFilters;
		},

		addEntity: function(entity){
			// add entity to dom if possible
			if(this.config.isReady && (this.model.$table || []).length > 0){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }));
			}
		},

		showEdit: function(rowID, rowData, buttonMode){
			if (rowID) {
				this.closest('templates_protocol_protocol_controller', function(component){
					component.showEdit('protocolAction', rowData)
				})
			}
		},

		customClickHandler: function(event){
			return false;
		},
	},
}
